import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

// Icons for Investor Resources

import "../components/my_global.scss"
import "../components/responsive-homepage.css"
import "../sass/main.scss"
import loadable from "@loadable/component"

import ArticleListItem from "../components/articleList/articleListItem"
import ArticleLeft from "../components/articleList/articleLeft"
import { getSrc } from "gatsby-plugin-image"
import placeholder from "../images/place-holder.webp"
import MySwiper from "../components/swiper/awards-swiper"

import logo1 from "../images/news-logos/investopedia-2.png"
import logo2 from "../images/news-logos/investopedia.png"
import logo3 from "../images/news-logos/wealth-management.png"
import logo4 from "../images/news-logos/expertise.png"
import logo5 from "../images/news-logos/expertise-2.png"
import logo6 from "../images/news-logos/channel-futures.png"
import logo7 from "../images/news-logos/marquis.png"

const VideoComponent = loadable(() =>
  import("../components/iframes/homepage-vid")
)
const BannerHero = loadable(() => import("../components/banner-hero"))
const PeopleGallery = loadable(() =>
  import("../components/people/people-gallery")
)

class IndexPage extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const posts = this.props.data.allSanityPost.edges.map((t) => t.node)

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title={siteTitle} description={siteDescription} />
        <BannerHero />
        <div className="section_padding whatwedo">
          <div className="container">
            <div className="row text-center mb-5">
              <div className="col-md-6 mx-auto">
                <div className="section-heading text-center">
                  <h2 className="section-title">What We Do</h2>
                  <p>
                    Bay Street Capital Holdings is a leading provider of
                    investment, advisory, wealth management, and financial
                    planning services. As a fiduciary, we invest on the behalf
                    of our clients with integrity, focus, and careful
                    stewardship of their capital. Our mission is to inspire the
                    next generation of diversified investors through the
                    investment of alternative asset classes with priority on
                    managing total risk and volatility.
                  </p>
                  {/* <Link to="/contact" className="solid-btn-homepage my-3">
                    LEARN MORE
                  </Link> */}
                </div>
              </div>
            </div>
            <div className="row text-center mt-5 pt-5">
              <div className="col-md-6 col-lg-6 col-xl-4 mb-3 mx-auto">
                <div className="whatwedo-list-item">
                  <svg
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 483.013 483.013"
                    fill="#16335a"
                  >
                    <path
                      d="M477.043,219.205L378.575,48.677c-7.974-13.802-22.683-22.292-38.607-22.292H143.041c-15.923,0-30.628,8.49-38.608,22.292
	L5.971,219.205c-7.961,13.801-7.961,30.785,0,44.588l98.462,170.543c7.98,13.802,22.685,22.293,38.608,22.293h196.926
	c15.925,0,30.634-8.491,38.607-22.293l98.469-170.543C485.003,249.99,485.003,233.006,477.043,219.205z"
                    />
                  </svg>
                  <div className="my-3 my_card_title text-center">
                    Asset
                    <br /> Management
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 col-xl-4 mb-3 mx-auto">
                <div className="whatwedo-list-item">
                  <svg
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 483.013 483.013"
                    fill="#d1ac79"
                  >
                    <path
                      d="M477.043,219.205L378.575,48.677c-7.974-13.802-22.683-22.292-38.607-22.292H143.041c-15.923,0-30.628,8.49-38.608,22.292
	L5.971,219.205c-7.961,13.801-7.961,30.785,0,44.588l98.462,170.543c7.98,13.802,22.685,22.293,38.608,22.293h196.926
	c15.925,0,30.634-8.491,38.607-22.293l98.469-170.543C485.003,249.99,485.003,233.006,477.043,219.205z"
                    />
                  </svg>
                  <div className="my-3 my_card_title">
                    Private
                    <br /> Equity
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 col-xl-4 mb-3 mx-auto">
                <div className="whatwedo-list-item">
                  <svg
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 483.013 483.013"
                    fill="#809fb0"
                  >
                    <path
                      d="M477.043,219.205L378.575,48.677c-7.974-13.802-22.683-22.292-38.607-22.292H143.041c-15.923,0-30.628,8.49-38.608,22.292
	L5.971,219.205c-7.961,13.801-7.961,30.785,0,44.588l98.462,170.543c7.98,13.802,22.685,22.293,38.608,22.293h196.926
	c15.925,0,30.634-8.491,38.607-22.293l98.469-170.543C485.003,249.99,485.003,233.006,477.043,219.205z"
                    />
                  </svg>
                  <div className="my-3 my_card_title">
                    Real <br /> Estate
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 col-lg-6 col-xl-3 mb-3">
                <div className="whatwedo-list-item">
                  <svg
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 483.013 483.013"
                    fill="#0a303f"
                  >
                    <path
                      d="M477.043,219.205L378.575,48.677c-7.974-13.802-22.683-22.292-38.607-22.292H143.041c-15.923,0-30.628,8.49-38.608,22.292
	L5.971,219.205c-7.961,13.801-7.961,30.785,0,44.588l98.462,170.543c7.98,13.802,22.685,22.293,38.608,22.293h196.926
	c15.925,0,30.634-8.491,38.607-22.293l98.469-170.543C485.003,249.99,485.003,233.006,477.043,219.205z"
                    />
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                  </svg>
                  <div className="my-3 my_card_title">Life Insurance</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="section_padding mission">
          <div className="container">
            <div className="row text-center mb-5">
              <div className="col-md-6 mx-auto">
                <div className="section-heading text-center">
                  <div className="my_h1">OUR MISSION</div>

                  <h2 className="section-title">
                    Inspiring the Next Generation of Diversified Thinkers
                  </h2>
                  <Link to="/contact" className="solid-btn-homepage my-3">
                    LEARN MORE
                  </Link>
                </div>
              </div>
            </div>
            <div className="row text-center mt-5 pt-5">
              <div className="col-md-6 col-lg-3 mb-3">
                <div className="mission-list-item">
                  <StaticImage
                    className="my-3"
                    src="../images/accountability.png"
                  />
                  <div className="my-3 my_card_title">
                    Accountability & Transparency
                  </div>
                  <div className="color_dark my-3 my_card_desc">
                    We value the trust our clients place in us and uphold the
                    highest standards of integrity
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-3">
                <div className="mission-list-item">
                  <StaticImage
                    className="my-3"
                    src="../images/performance.png"
                  />
                  <div className="my-3 my_card_title">Performance-Oriented</div>
                  <div className="color_dark my-3 my_card_desc">
                    We invest with high conviction, through the lens of history,
                    in companies that will outperform
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-3">
                <div className="mission-list-item">
                  <StaticImage className="my-3" src="../images/strategy.png" />
                  <div className="my-3 my_card_title">Strategy</div>
                  <div className="color_dark my-3 my_card_desc">
                    We create a fortified strategic approach with tailored
                    financial solutions to help achieve your goals
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-3">
                <div className="mission-list-item">
                  <StaticImage
                    className="my-3"
                    src="../images/comprehensive.png"
                  />
                  <div className="my-3 my_card_title">
                    Comprehensive Planning
                  </div>
                  <div className="color_dark my-3 my_card_desc">
                    We develop an exceptional, comprehensive financial plan
                    customized to your finances and goals
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section_padding awards">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="text-left section-heading">
                  <h2 className="section-title text-gold text-left mb-3 text-white">
                    Awards and Recognitions
                  </h2>
                  <h5 className="text-white">
                    We are honored to be recognized for our accomplishments and
                    our financial performance
                  </h5>
                </div>
              </div>
              <div className="col-md-8">
                <MySwiper slidesperview="3">
                  <div>
                    <img src={logo1} className="img-fluid"></img>
                  </div>
                  <div>
                    <img src={logo2} className="img-fluid"></img>
                  </div>
                  <div>
                    <img src={logo3} className="img-fluid"></img>
                  </div>
                  <div>
                    <img src={logo4} className="img-fluid"></img>
                  </div>
                  <div>
                    <img src={logo5} className="img-fluid"></img>
                  </div>
                  <div>
                    <img src={logo6} className="img-fluid"></img>
                  </div>
                  <div className="awards-item">
                    <img src={logo7} className="img-fluid"></img>
                  </div>
                </MySwiper>
              </div>
            </div>
          </div>
          <div className="overlay"></div>
        </div>
        <div className="section_padding values">
          <div className="container">
            <div className="row">
              <div className="values-body">
                <div className="col-md-6 col-lg-5">
                  <div className="text-left section-heading section-info">
                    <h2 className="section-title text-left mb-3 text-dark">
                      Our Values
                    </h2>
                    <h5 className="text-dark">
                      Bay Street Capital Holdings is an independent investment
                      advisory, wealth management, and financial firm
                      headquartered in Palo Alto, California. We manage
                      portfolios with the goal of maintaining and increasing
                      total assets and income. Although many advisors may focus
                      on maximizing returns, we place a higher priority on
                      managing total risk and volatility.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section_padding home-quote">
          <div className="container">
            <div className="row">
              <div className="qoute-body">
                <div className="col-lg-6">
                  <div className="text-left section-info">
                    <h4 className="mb-3">
                      “It is our core belief that designing a portfolio through
                      the appropriate mix of assets for each unique investor is
                      the key to successful, long-term investing. Selecting fund
                      managers for each asset class is a factor, but
                      meticulously designing the asset allocation is what
                      ultimately determines a portfolio’s failure or success.”
                    </h4>
                    <h6 className="text-dark">
                      -William Huston, Founder, Chief Investment Officer
                    </h6>
                  </div>
                </div>
                <div className="col-md-12 d-lg-none mt-4">
                  <StaticImage
                    placeholder="blurred"
                    layout="constrained"
                    fit="cover"
                    src="../images/william.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section_padding blog">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 mx-auto">
                <div className="section-heading">
                  <h2 className="section-title  text-left mb-3">
                    What We’re Thinking
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 mb-5">
                {posts.slice(0, 1).map((article, idx) => (
                  <>
                    <ArticleListItem
                      key={idx}
                      idx={article.idx}
                      link={article.slug.current}
                      banner={
                        article?.mainImage !== null
                          ? getSrc(article?.mainImage?.asset?.gatsbyImageData)
                          : placeholder
                      }
                      categories={
                        article.categories.length ? article.categories : null
                      }
                      title={article.title}
                      excerpt={
                        article.excerpt
                          ? article.excerpt.length > 70
                            ? `${article.excerpt.substring(0, 70)}...`
                            : article.excerpt
                          : article.videoUrl
                          ? article.videoUrl
                          : null
                      }
                      authorImage={
                        getSrc(article?.authors?.image?.asset?.gatsbyImageData)
                          ? getSrc(
                              article?.authors?.image?.asset?.gatsbyImageData
                            )
                          : null
                      }
                      author={article.authors.name}
                      publishedAt={article.publishedAt}
                    />
                  </>
                ))}
              </div>
              <div className="col-lg-6">
                {posts.slice(1, 4).map((article, idx) => (
                  <>
                    <ArticleLeft
                      key={idx}
                      idx={article.idx}
                      link={article.slug.current}
                      banner={
                        article?.mainImage !== null
                          ? getSrc(article?.mainImage?.asset?.gatsbyImageData)
                          : placeholder
                      }
                      categories={
                        article.categories.length ? article.categories : null
                      }
                      title={article.title}
                      excerpt={
                        article.excerpt
                          ? article.excerpt.length > 70
                            ? `${article.excerpt.substring(0, 70)}...`
                            : article.excerpt
                          : article.videoUrl
                          ? article.videoUrl
                          : null
                      }
                      authorImage={
                        getSrc(article?.authors?.image?.asset?.gatsbyImageData)
                          ? getSrc(
                              article?.authors?.image?.asset?.gatsbyImageData
                            )
                          : null
                      }
                      author={article.authors.name}
                      publishedAt={article.publishedAt}
                    />
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default IndexPage

export const indexPageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allSanityPerson(
      filter: { roles: { eq: "Client" } }
      sort: { order: ASC, fields: bydepartmentOrder }
    ) {
      edges {
        node {
          bydepartmentOrder
          name
          slug {
            current
          }
          roles
          position
          image {
            asset {
              gatsbyImageData(formats: [WEBP, AVIF])
            }
          }
        }
      }
    }
    allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      filter: { language: { eq: "en" } }
    ) {
      edges {
        node {
          id
          title
          language
          slug {
            current
          }
          featured
          mainImage {
            asset {
              gatsbyImageData
            }
            alt
          }
          publishedAt(formatString: "MMMM DD, YYYY")
          excerpt
          videoUrl
          categories {
            id
            title
          }
          authors {
            name
            image {
              asset {
                gatsbyImageData(width: 50, height: 50)
              }
            }
          }
        }
      }
    }
  }
`
